import { CircularProgress, TextField } from '@material-ui/core';
import { TextFieldProps } from '@material-ui/core/TextField';
import { makeStyles, Theme } from '@material-ui/core/styles';
import Autocomplete from '@material-ui/lab/Autocomplete';
import React from 'react';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    '& .MuiOutlinedInput-root': {
      '&:hover fieldset': {
        borderColor: '#264259',
      },
    },
  },
  inputColor: {
    color: theme.palette.primary.main,
  },
  inputRoot: {
    color: theme.palette.primary.main,
    marginBottom: theme.spacing(1),
  },
  tag: {
    color: theme.palette.primary.main,
    fontSize: 14,
  },
}));

interface TextSelectProps {
  itens?: { ordem: string; titulo: string }[];
  options?: Array<{ label: string; value: any }>;
  getOptionLabel: (option: any) => string;
  onChange: (value: any) => void;
  values?: any[];
  value?: any;
  loading?: boolean;
}

const SelectAPI: React.FC<TextFieldProps & TextSelectProps> = props => {
  const classes = useStyles();
  const isLoading = Boolean(props.loading);
  const isDisabled = Boolean(props.disabled) || isLoading;

  const makeLabelOptions = (itens: any[]): Array<{ label: string; value: any }> => {
    const options: Array<{ label: string; value: any }> = [];
    itens.forEach(item => {
      for (const key in item) {
        options.push({
          value: item[key],
          label: item[key],
        });
      }
    });
    return options;
  };

  const options = props.options ?? makeLabelOptions(props.itens ?? []);
  const selectedValue =
    props.value === null || props.value === undefined || props.value === ''
      ? null
      : options.find(option => String(option.value) === String(props.value)) ?? null;

  return (
    <Autocomplete<{ label: string; value: any }>
      id="tags-outlined"
      options={options}
      loading={isLoading}
      loadingText="Carregando..."
      disabled={isDisabled}
      classes={{
        inputRoot: classes.inputRoot,
        tag: classes.tag,
        option: classes.tag,
      }}
      getOptionLabel={option => props.getOptionLabel(option)}
      getOptionSelected={(option, selected) => String(option.value) === String(selected.value)}
      value={selectedValue}
      onChange={(_event, selected) => {
        if (!selected || typeof selected === 'string') {
          props.onChange(null);
          return;
        }
        props.onChange({
          label: selected.label,
          value: selected.value,
        });
      }}
      filterSelectedOptions
      renderInput={params => (
        <TextField
          {...params}
          variant="outlined"
          placeholder={isLoading ? 'Carregando...' : '...'}
          error={props.error}
          label={props.label}
          helperText={
            isLoading
              ? 'Carregando informações...'
              : props.helperText
          }
          fullWidth
          InputProps={{
            ...params.InputProps,
            className: classes.inputColor,
            endAdornment: (
              <>
                {isLoading ? (
                  <CircularProgress color="inherit" size={20} />
                ) : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  );
};

export default SelectAPI;
